import { MODEL_SOURCES } from 'Pods/ThreeDStudio/Services/Constants/modelSources'
import { ACTION } from 'Pods/ThreeDStudio/Store/constants'

// Only a base text-to-3d or image-to-3d run can seed an enhancement's
// source_run_id. Mirrors Generator::Run#source_eligible? (SOURCE_ACTIONS) on the
// backend, which rejects enhanced runs (retexture, mesh-simplification, etc.).
const SOURCE_ACTIONS = [ACTION.TEXT_TO_3D, ACTION.IMAGE_TO_3D]

/**
 * Whether the given provider model id is a base generation (text-to-3d or
 * image-to-3d) that can act as the remix source for an enhancement.
 * @param {string|undefined} providerModelId - openedModel.providerModelId
 * @returns {boolean}
 */
export const isSourceGenerationModel = (providerModelId) => {
  if (!providerModelId) {
    return false
  }

  const model = MODEL_SOURCES.find((source) => source.model_id === providerModelId)
  return model != null && SOURCE_ACTIONS.includes(model.action)
}
